(function () {
    'use strict';

    function main() {
        var controller = {
            init: function () {
                var widgets = wo$('[data-widget-type="phone"]');
                if (!widgets.length) return;

                widgets.off('click');
                widgets.on('click', '#view-full-details', function () {
                    WhistleOut.trackEvent('MobilePhone', 'ViewFullDetails');
                });
                widgets.on('click', '#view-manufacturer', function () {
                    WhistleOut.trackEvent('MobilePhone', 'ViewManufacturer', wo$(this).data('manufacturer'));
                });
                widgets.on('click', '#view-review', function () {
                    WhistleOut.trackEvent('MobilePhone', 'ViewReview');
                });
                widgets.on('click', '#view-plans', function () {
                    WhistleOut.trackEvent('MobilePhone', 'ViewPlans');
                });
                widgets.on('click', '[data-view-carrier]', function () {
                    WhistleOut.trackEvent('MobilePhone', 'ViewSupplier', wo$(this).data('view-carrier'));
                });
                widgets.on('click', '#view-whistleout', function () {
                    WhistleOut.trackEvent('MobilePhone', 'Whistleout');
                });
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
